import React from 'react';
import Candidate from './Candidate'

class Candidates extends React.Component {
  _getCandidates(candidates) {
    return candidates.props.map((candidate) => {
      return(<Candidate key={candidate.id} {...candidate}/>)
    });
  }

  render() {
    const candidates = this._getCandidates(this.props)
    return (
      <div>
        <table className="table is-striped">
          <thead>
            <tr>
              <th><abbr title="First Name">Frist</abbr></th>
              <th><abbr title="Last Name">Last</abbr></th>
              <th className="is-hidden-mobile"><abbr title="Phone Number">Phone</abbr></th>
              <th className="is-hidden-mobile"><abbr title="Email Address">Email</abbr></th>
              <th className="is-hidden-mobile"><abbr title="Zip">Zip</abbr></th>
              <th className="is-hidden-mobile"><abbr title="Small Business Sales">Experience</abbr></th>
              <th className="is-hidden-mobile"><abbr title="Selling to small business">Selling</abbr></th>
              <th><abbr title="Accept/Reject">Accept/Reject</abbr></th>
            </tr>
          </thead>
          <tbody>
            { candidates }
          </tbody>
        </table>
      </div>
    )
  }
}

export default Candidates
